import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import itCommon from "@/i18n/it/common.json";
import itCategories from "@/i18n/it/categories.json";
import itNeeds from "@/i18n/it/needs.json";

// Switch lingua rimosso dalla UI: per il momento l'app resta sempre in italiano.
i18n.use(initReactI18next).init({
  lng: "it",
  fallbackLng: "it",
  defaultNS: "common",
  ns: ["common", "categories", "needs"],
  resources: {
    it: { common: itCommon, categories: itCategories, needs: itNeeds },
  },
  interpolation: { escapeValue: false },
});

export default i18n;
